module.exports = __webpack_public_path__ + "img/stockQueryAct.37f0fbc0.png";